import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const ConfirmDeployModal = ({
    onConfirm,
    onClose
}) => {
    const [translate] = useTranslation();

    return <Modal
        size={'lg'}
        show={true}
        backdrop={'static'}>
        <Modal.Header>
            <label className="h5">
                {translate("OTM_CONFIRM_DEPLOYMENT_HEADER")}
            </label>
        </Modal.Header>

        <Modal.Body>
            <span className="fw-bold">
                {translate("OTM_CONFIRM_DEPLOYMENT_INFO_TITLE")}
            </span>

            <ul>
                <li className="mt-2">
                    {translate("OTM_CONFIRM_DEPLOYMENT_INFO_LIST_1")}
                </li>

                <li className="mt-2">
                    {translate("OTM_CONFIRM_DEPLOYMENT_INFO_LIST_2")}
                </li>

                <li className="mt-2">
                    {translate("OTM_CONFIRM_DEPLOYMENT_INFO_LIST_3")}
                </li>

                <li className="mt-2">
                    {translate("OTM_CONFIRM_DEPLOYMENT_INFO_LIST_4")}
                </li>
            </ul>

        </Modal.Body>

        <Modal.Footer>
            <Button size='sm' variant='primary' onClick={onConfirm}>{translate('OTM_CONFIRM')} </Button>
            <Button size='sm' variant='secondary' onClick={onClose}>{translate('OTM_CANCEL')} </Button>
        </Modal.Footer>
    </Modal>
}

export default ConfirmDeployModal;